var React = require('react');
var createReactClass = require('create-react-class');
var PropTypes = require('prop-types');
var SearchResult = require('./SearchResult');


var SearchResultsList = createReactClass({
	propTypes: {
		onProfileView: PropTypes.func.isRequired,
	},

	render: function () {
		var searchNodes = this.props.data.map(function(searchResult) {
			return (
				<SearchResult key={searchResult.profileSlug} result={searchResult} onProfileView={this.props.onProfileView} />
			);
		}.bind(this));

		return (
			<div className="search-results-list">
				{searchNodes}
			</div>
		);
	}
});

module.exports = SearchResultsList;